import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth hardening (Feb 2026): JWT lives in an httpOnly cookie set by the
// backend on /api/auth/login. All requests send `credentials: 'include'` so
// the cookie rides along; we no longer read/write it from JS.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// SEC-002: use <AuthImage> / <AuthAudio> from components/AuthMedia for protected
// files — the browser sends the auth cookie automatically.
